import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AnalyticsService, ApplicationInsightsService } from '@crosscutting/public_api';

import { VMDataService } from '../../../vm_api';
import { VeiligheidsMeter, VMTip,VMModule } from '../../../vm_models';
import { ContentHelper } from '../../../services/helpers/content-helper';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TipsComponent implements OnInit {
  @Input() currentVMModule: VMModule;
  @Input() currentVMTipId: string;
  @Input() pageTitle = '[Not set]';
  @Input() pageContent = '[Not set]';

  veiligheidsMeter: VeiligheidsMeter;
  meerTipsTitle = '[not set]';
  currentVMTips: Array<VMTip>;
  nextTitle = '[not set]';
  nextOverzicht = '[not set]';
  tipLinkText = '[not set]';
  tipLinkAria = '[not set]';
  paza = document.body.dataset.paza || '';
  pagename = document.body.dataset.pagename || '';
  pageinfo = 'Pagina met tips'

  constructor(
    private _vmDataService: VMDataService,
    private _analyticsService: AnalyticsService,
    private _applicationInsightsService: ApplicationInsightsService,
    private _router: Router,
  ) { }

  ngOnInit() {
    this.veiligheidsMeter = this._vmDataService.getVeiligheidsMeter();

    if (this.isReady) {
      this.setCurrentModule(this.veiligheidsMeter.currentVMModule);
      this.setPageContent();
      this.setDynamicContent();
      this.setTips();
      this.initAnalytics('/tips', 2000);
    } else {
      /* ssomething is lost, let's start over... */
      this._router.navigate(['/intro']);
    }
  }

  /* get tips to show */
  public get filterCurrent() {
    return this.currentVMTips.filter(x => x.id != this.currentVMTipId);
  }

  public get isReady():boolean {
    return this.veiligheidsMeter && this.veiligheidsMeter.currentVMTip?.length > 0;
  }

  /* (re)init analytics */
  initAnalytics(page: string, timeout: number) {
    setTimeout(() => {
      this._analyticsService.celebrusReinit();
      this._applicationInsightsService.logPageView(null, page);
    }, timeout);
  }

  /* helper: get module based on unique key value */
  getModule(key) {
    let index: number;

    index = this.veiligheidsMeter.vmModules.findIndex(x => x.key === key);
    return this.veiligheidsMeter.vmModules[index];
  }

  /* return to overzicht */
  goToOverzicht() {
    this._router.navigate(['/intro']);
  }
  
  /* go to selected tip*/
  goToTip(id) {
    this.currentVMTipId = id;
    this.pageinfo = 'tip: ' + this.currentVMModule.tips.find(x => x.id == id).content.title;
    this.setDynamicContent();
  }
  
  /* set the selected module as current module*/
  setCurrentModule(id) {
    this.currentVMModule = this.getModule(id);

    if (this.currentVMModule.status == '') {
      /* something is lost, let's start over... */
      this._router.navigate(['/intro']);
    }
  }

  /* set content of tip */
  setDynamicContent() {
    let currentModule = this.veiligheidsMeter.vmModules.find(x => x.key == this.veiligheidsMeter.currentVMModule);

    this.pageTitle = currentModule.tips.find(x => x.id === this.currentVMTipId).content.title;
    this.pageContent = currentModule.tips.find(x => x.id === this.currentVMTipId).content.content;
    this.pageinfo = 'tip: ' + this.pageTitle;
    window.scrollTo({top: 0, behavior: "smooth"});
  }
  
  /* get the right content from contentitems */
  setPageContent() {
    let content = ContentHelper.getContent('tips');

    this.currentVMTipId = this.veiligheidsMeter.currentVMTip;
    Object.keys(content).forEach((key) => {
      let item = Object.keys(content[key])[0];

      if (this[key]) {
        let contentItem;
        
        try { 
          contentItem = this.veiligheidsMeter.vmContentItems.find(x => x.id === content[key][item])[item];
          this[key] = contentItem;
        } catch {} 
      } else {}
    });
  }

  /* set current tips*/
  setTips() {
    let tips = this.currentVMModule.tips;

    if (tips) {
      tips.forEach((tip, index) => {
        let tipContent =this.veiligheidsMeter.vmContentItems.find(x => x.id === tip.id);
        tip.content = tipContent;
      })
    }
    
    this.currentVMTips = tips;
  }
}
